<script>
  import { browser } from "$app/environment";
  import {
    fetchExperimentVariant,
    getRechargeCtaVisibilitiy,
    logout,
    splashScreenConfig,
  } from "@/api";
  import config from "@/config";
  import trackEvents from "@/events";
  import experimentStore from "@/stores/experimentStore";
  import profileStore from "@/stores/profile";
  import "@/style/index.scss";
  import "@/style/main.css";
  import { isProtectedRoute, reportError } from "@/utils";
  import importWithRetry from "@/utils/helpers/importWithRetry";
  import { getSafeSearchParam } from "@mohalla-tech/xss-safeguard";
  import lazySizes from "lazysizes";
  import "lazysizes/plugins/attrchange/ls.attrchange";
  import { onMount } from "svelte";
  import { get } from "svelte/store";

  let error = null;
  let isMounted = false;

  $: if (isMounted && error) {
    reportError(error);
    error = null;
  }

  // $:
  // const handleError = err => {
  // 	if (err) error = err;
  // };

  // const checkForDarkTheme = () => {
  //   if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
  //     document.body.classList.add("dark");
  //   } else {
  //     document.body.classList.remove("dark");
  //   }
  // };

  const fetchExperimentList = async () => {
    const expIdList = config.experimentsList.map((exp) => exp.expId);
    let experimentData = {};
    try {
      const experimentList = await fetchExperimentVariant(expIdList);
      experimentList &&
        Array.isArray(experimentList) &&
        experimentList.forEach((exp) => {
          const { expList = [] } = exp;
          expList?.forEach(({ expId, variant }) => {
            experimentData[expId] = variant;
          });
        });
      experimentStore.updateState(experimentData);
    } catch (e) {
      console.error(e);
    }
  };

  onMount(async () => {
    if (($profileStore.isTempAuth || $profileStore.isAuth) && browser) {
      trackEvents("PwaAuthenticatedHomeOpened", {
        referrer: location.pathname,
      });
    }
    splashScreenConfig();
    const tenant = getSafeSearchParam("tenant");
    if (
      isProtectedRoute(location.pathname) &&
      (!$profileStore.isAuth || (tenant && tenant !== $profileStore.tenant))
    ) {
      const redirectUrl = location.pathname;
      logout(true, { redirectUrl });
    }

    const currentUrl = location.href;
    trackEvents("HomeOpened", {
      referrer: currentUrl,
    });

    // page is optimized for fast onload event
    try {
      await importWithRetry(() =>
        import("lazysizes/plugins/unveilhooks/ls.unveilhooks")
      ); // eslint-disable-line
    } catch (err) {
      console.log(err);
    }

    try {
      const profileState = get(profileStore);
      if (profileState.isAuth) {
        const response = await getRechargeCtaVisibilitiy(
          fetch,
          profileState.userId
        );
        profileStore.updateState({
          showRechargeCta: response?.is_enabled,
        });
      }
    } catch (err) {
      console.log(err);
    }

    lazySizes.cfg.loadMode = 1;
    fetchExperimentList();
    // if (window.matchMedia) {
    //   // checkForDarkTheme();
    //   window
    //     .matchMedia("(prefers-color-scheme: dark)")
    //     .addEventListener("change", checkForDarkTheme);
    // }
    isMounted = true;
  });
</script>

<slot />
